@if (block(); as block) {
  <article class="block-wysiwyg container">
    <div class="row">
      <div class="col-md-14 mx-auto">
        @if ((block.title || block.subtitle) && !block.hideTitle) {
          <header class="text-max-width-sm mx-auto">
            @if (block.subtitle) {
              <strong class="fs-body-md fw-semi mb-2 text-primary d-inline-block w-100">{{ block.subtitle }}</strong>
            }
            @if (block.title) {
              <h2 class="h3 mb-0">
                {{ block.title }}
              </h2>
            }
          </header>
        }

        @if (block.text) {
          <!--<div
            class="markdown-content mt-3"
            fstrDynamicContent
            [innerHTML]="block.text | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
          ></div>-->

          <ngx-dynamic-hooks
            class="markdown-content d-block text-max-width-sm mx-auto"
            [class.mt-3]="(block.title || block.subtitle) && !block.hideTitle"
            [options]="{ sanitize: false, updateOnPushOnly: true }"
            [content]="block.text | resizeHtmlImages | stripEmbed: cookiePreferences() || undefined"
            fstrDynamicContent
          ></ngx-dynamic-hooks>
        }

        @if (block.button?.url || block.secondaryButton?.url) {
          <footer class="mt-4 d-flex flex-wrap gap-2 text-max-width-sm mx-auto">
            @if (block.button?.url) {
              <fstr-link [button]="block.button!" [cssClasses]="'button button--primary'"></fstr-link>
            }
            @if (block.secondaryButton?.url) {
              <fstr-link [button]="block.secondaryButton!" [cssClasses]="'button button--primary-subtle'"></fstr-link>
            }
          </footer>
        }
      </div>
    </div>
  </article>
}
